import rootStore from '../store'

/**
 * Default Global Authorization Guard
 */
export default function (to, from, next) {
  const store = rootStore

  if (to.matched.some(function (record) { return record.meta.requiresAuth })) {
    // this route requires auth, check if profile has been retrieved already
    // if not, retrieve it - then navigate.
    // if retrieval fails, then cancel navigation
    if (!store.getters.accountRetrieved) {
      // TODO retrieve account details
      console.log('Need to retrieve account details here!')
      store.dispatch('userAccountRegister')
        .then(() => {
          next()
        })
        .catch(() => {
          next(false)
        })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
}



// WEBPACK FOOTER //
// ./src/router/profileGuard.js